import { Translation } from "../components/common/translation";

declare const gon: any;

$(document).ready(function() {
  Translation.AddDictionary(gon.translations);
});
